import { FC, useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';
import { $HashtagPopularPostLoadmore, $HashtagRecentPostLoadmore } from 'shared/atoms';
import { $CurrentHashtagPopularPosts, $CurrentHashtagRecentPosts } from '@hashtag/shared/current-hashtag-post';
import { useRouteLoader } from '@lemon8/web-app-shared/ssr';
import { Loaders } from 'shared/constant';
import LoadMore from '~/components/load-more';
import { ArticleCard } from '~/components/article-card';
import { Loading } from '~/components/loading';
import { useTranslation } from 'react-i18next';

interface IHashtagPostFragmentProps {
  type: 'popular' | 'recent';
  active: boolean;
}

export const HashtagPostFragment: FC<IHashtagPostFragmentProps> = ({ type, active }) => {
  const { t } = useTranslation();
  const { items, sessionImprId, hasMore } = useAtomValue(
    type === 'popular' ? $CurrentHashtagPopularPosts : $CurrentHashtagRecentPosts,
  );

  const loader = useRouteLoader(
    Loaders.Hashtag.HashtagPostsLoadmore,
    {
      type,
      session_impr_id: sessionImprId,
    },
    {
      atomFamilies: {
        $HashtagPopularPostLoadmore,
        $HashtagRecentPostLoadmore,
      },
    },
  );

  const loadData = (): Promise<{ data: unknown[] }> => {
    if (active) {
      loader.load();
    }
    return Promise.resolve({ data: [] });
  };

  const initializedRef = useRef(false);
  useEffect(() => {
    if (active && !initializedRef.current) {
      loadData();
      initializedRef.current = true;
    }
  }, [active]);

  return (
    <LoadMore
      loadData={loadData}
      isEnd={!hasMore}
      endText={t('no_more_items')}
      render={() => {
        return (
          <>
            {items.map((item) => (
              <ArticleCard key={item.groupId} article={item} />
            ))}
            {hasMore && <Loading variant="ball" />}
          </>
        );
      }}
    />
  );
};
